// Practice — box-breathing interactive.
//
// "Begin" starts a 16s cycle (4s in, 4s hold, 4s out, 4s hold).
// Label inside the orb updates each phase. Pressing again stops
// and resets to "Ready". Animation itself is CSS (gg-breathe
// keyframes); JS only toggles the running class and cycles the
// label text in sync with the animation phases.

const PHASES = ["In", "Hold", "Out", "Hold"];
const PHASE_MS = 4000;

export default function practice() {
    const stage = document.querySelector("[data-practice]");
    if (!stage) return;

    const orb = stage.querySelector("[data-practice-orb]");
    const label = stage.querySelector("[data-practice-label]");
    const btn = document.querySelector("[data-practice-btn]");
    if (!orb || !label || !btn) return;

    const btnLabel = btn.querySelector("[data-practice-btn-label]") || btn;
    const startLabelText = btnLabel.textContent;

    let running = false;
    let phaseTimer = null;
    let phaseIdx = 0;

    function tick() {
        phaseIdx = (phaseIdx + 1) % PHASES.length;
        label.textContent = PHASES[phaseIdx];
    }

    function start() {
        running = true;
        orb.classList.add("is-running");
        phaseIdx = 0;
        label.textContent = PHASES[0];
        btnLabel.textContent = "Stop";
        btn.setAttribute("aria-pressed", "true");
        phaseTimer = setInterval(tick, PHASE_MS);
    }

    function stop() {
        running = false;
        orb.classList.remove("is-running");
        clearInterval(phaseTimer);
        phaseTimer = null;
        label.textContent = "Ready";
        btnLabel.textContent = startLabelText;
        btn.setAttribute("aria-pressed", "false");
    }

    btn.addEventListener("click", () => {
        if (running) stop();
        else start();
    });
}
